module.exports = __webpack_public_path__ + "static/media/jade.e1d2f68d.jpg";